import { render } from "./multiFile.vue?vue&type=template&id=659c6c88&scoped=true"
import script from "./multiFile.vue?vue&type=script&lang=js"
export * from "./multiFile.vue?vue&type=script&lang=js"

import "./multiFile.vue?vue&type=style&index=0&id=659c6c88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659c6c88"]])

export default __exports__